/**
 * Convert a zero-based index to a spreadsheet-style column label: A, B, ... Z, AA, AB, ...
 */
function indexToColumnLabel(index: number): string {
  let label = '';
  let n = index;
  do {
    label = String.fromCharCode(65 + (n % 26)) + label;
    n = Math.floor(n / 26) - 1;
  } while (n >= 0);
  return label;
}

/**
 * Compute a branch label (A, B, ... Z, AA, AB...) for an edge based on its position among the
 * source step's conditioned outgoing edges. Returns '' when there is only one condition.
 */
export function computeBranchLabel(edge: {
  toStep: {id: string};
  fromStep: {outgoingEdges?: Array<{condition?: unknown; toStep: {id: string}}>};
}): string {
  const conditionedEdges = edge.fromStep.outgoingEdges?.filter((e) => e.condition != null);
  if (conditionedEdges == null || conditionedEdges.length <= 1) {
    return '';
  }
  const idx = conditionedEdges.findIndex((e) => e.toStep.id === edge.toStep.id);
  if (idx === -1) {
    return '';
  }
  return indexToColumnLabel(idx);
}
